import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpService
  ) { }

  async setAdminPassword(password: string): Promise<boolean> {
    const requestBody = { "password": password };
    return await this.http.post<boolean,any>(`${environment.adminConfig.apiUri}/profile/setadminpassword`, requestBody);
  }

}
